import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { Color, FontSize, Symbol } from "../../../constants"

type Props = {
    value: string | React.ReactNode
    subValue: Maybe<string> | React.ReactNode
}

const TwoRowsCell = (props: Props) => {
    return (
        <div className="twoRowsCell">
            <style jsx={true}>
                {`
                    .twoRowsCell {
                        display: inline-block;
                    }
                    .twoRowsCell .value {
                        position: relative;
                    }
                    .twoRowsCell .subValue {
                        color: ${Color.Grey};
                        font-size: ${FontSize.xs};
                        position: relative;
                    }
                `}
            </style>
            <div className="value">{props.value || Symbol.MDash}</div>

            <div className="subValue">{props.subValue || Symbol.MDash}</div>
        </div>
    )
}

export default TwoRowsCell
